import { RouteObject } from "../../interfaces/navigation";
import React from "react";
import MyAccount from "../../containers/Profile/MyAccount/EntryPointContainer";
import Favorites from "../../containers/Profile/Favorites/EntryPointContainer";
import { myBuysRoutes } from "./MyBuys/routes";
import { myPublicationsRoutes } from "./MyPublications/routes";
import { documentationRoutes } from "./Documentation/routes";
import { myOffersRoutes } from "./MyOffers/routes";
import Settings from "../../containers/Profile/Settings/EntryPointContainer";

const ProfileContainer = React.lazy(() => import("../../containers/Profile/ProfileContainer"));

export const profileSubRoutes: RouteObject[] = [
    {
        title: "Mi Cuenta",
        path: "cuenta",
        component: <MyAccount/>,
        protected: true,
        subRoutes: [
            ...documentationRoutes,
            {
                title: "Ajustes",
                path: "ajustes",
                component: <Settings/>,
                protected: true
            },
        ]
    },
    ...myPublicationsRoutes,
    ...myBuysRoutes,
    {
        title: "Favoritos",
        path: "favoritos",
        component: <Favorites/>,
        protected: true
    },
    ...myOffersRoutes,
];

export const profileRoutes: RouteObject[] = [
    {
        title: "Profile",
        path: "/perfil",
        component: <ProfileContainer/>,
        protected: true,
        subRoutes: profileSubRoutes
    }
];